import React from 'react';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../../util/translationUtility';

class MobileShowFacetsButton extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { onShowMobileFacetsToggle } = this.props;

        return (
            <button className="btn btn-cc-black" onClick={onShowMobileFacetsToggle}>
                {translateResourceString("/SearchApp/MobileFacets/ShowButton")}
            </button>
        );
    }
}

MobileShowFacetsButton.propTypes = {
    onShowMobileFacetsToggle: PropTypes.func.isRequired
};

export default MobileShowFacetsButton;